import React from 'react';
import { Check, ArrowRight } from 'lucide-react';
import '../websitepackages.css';

const WebsitePackages = () => {
  const packages = [
    {
      name: 'Basic Website (Best for New Businesses)',
      priceRange: '$299 - $499',
      description: '👉 Perfect for service businesses just getting started',
      features: [
        '3-5 professional pages',
        'Mobile-friendly & fast loading',
        'Basic SEO setup(Google-ready)',
        'Contact form that sends leads directly to your email',
        'Social media links',
        '30-day post-launch support',
        "FREE 30-day hosting included"
      ],
      popular: false,
      ctaText: 'Get Basic Package'
    },
    {
      name: 'Professional Website (Most Popular)',
      priceRange: '$799 - $1,299',
      description: '👉 Best for growing businesses that want consistent leads',
      features: [
        'Up to 10 custom pages',
        'Advanced mobile & speed optimazion',
        'Conversion-focused design(built to generate calls & form leads)',
        'Contact & inquiry forms',
        'Blog or content section',
        'SEO setup + Goolge Analytics',
        'Social media & lead tracking integration',
        '60-day support & maintenance',
        "FREE 30-day hosting included"
      ],
      popular: true,
      ctaText: 'Get Professional Package'
    },
    {
      name: ' Premium Website (For Scaling Businesses)',
      priceRange: '$1,499 - $2,499',
      description: '👉 Ideal for businesses ready to scale online',
      features: [
        'Unlimited pages',
        'E-commerce or booking system',
        'Fully custom premium design',
        'Advanced SEO & marketing tools',
        'User accounts & secure login',
        'Payment gateway integration',
        'Content management system(CMS)',
        '90-day support & maintenance',
        'Monthly performance reports',
        "90-day priority support & maintenance",
        "Free 30-day hosting included"
      ],
      popular: false,
      ctaText: 'Get Premium Package'
    }
  ];

  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="website-packages" className="website-packages">
      <div className="packages-container">
        <div className="packages-header">
          <h2 className="packages-title">
            Website Creation Packages
          </h2>
          <p className="packages-description">
            Professional website development tailored to your business needs. From simple landing pages to complex e-commerce solutions.
          </p>
        </div>

        <div className="packages-grid">
          {packages.map((pkg, index) => (
            <div 
              key={index} 
              className={`package-card ${pkg.popular ? 'popular' : ''}`}
            >
              {pkg.popular && (
                <div className="popular-badge">
                  Most Popular
                </div>
              )}
              
              <div className={`package-header ${pkg.popular ? 'with-badge' : ''}`}>
                <h3 className="package-name">
                  {pkg.name}
                </h3>
                <p className="package-description">
                  {pkg.description}
                </p>
                <div className="package-price">
                  {pkg.priceRange}
                </div>
              </div>

              <div className="package-content">
                <ul className="package-features">
                  {pkg.features.map((feature, featureIndex) => (
                    <li key={featureIndex} className="package-feature">
                      <Check size={20} />
                      <span className="package-feature-text">{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="package-footer">
                <button
                  onClick={scrollToContact}
                  className={`package-button ${pkg.popular ? 'popular' : 'standard'}`}
                >
                  {pkg.ctaText}
                  <ArrowRight size={16} />
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="packages-custom">
          <p className="packages-custom-description">
            Need something custom? We create bespoke solutions for unique business requirements.
          </p>
          <button
            onClick={scrollToContact}
            className="packages-custom-button"
          >
            Get My Professional Website
          </button>
        </div>
      </div>
    </section>
  );
};

export default WebsitePackages;